import type { Dayjs, IsoDateString } from '@skynet/formatting-date';
import type { GenericError, RequestStatus } from '@skynet/data-ws-core';
import { StrikePriceType } from './constants';

export enum StrikePricesCommands {
  LoanStrikes = 'LoanStrikes',
  AddStrikePrice = 'AddStrikePrice',
  EditStrikePrice = 'EditStrikePrice',
  RemoveStrikePrice = 'RemoveStrikePrice',
}

export interface FormStrikePrice {
  tokensAmount: string;
  strikePrice: number;
  strikeDate: Dayjs;
  endDate?: Dayjs; // optional — OTC strike prices have no end date
  strikeType: keyof typeof StrikePriceType;
  note: string;
}

export interface StrikePrice {
  id: number;
  tokensAmount: number;
  strikePrice: number;
  strikeDate: IsoDateString;
  endDate: IsoDateString;
  strikeType?: keyof typeof StrikePriceType;
  note: string;
}

export interface JsonStrikePrice {
  ID: number;
  TokensAmount: number;
  QuoteAmount: number;
  StrikePrice: number;
  StrikeDate: IsoDateString;
  EndDate: IsoDateString;
  StrikeType?: keyof typeof StrikePriceType;
  Note: string;
}

export interface StrikePricesState {
  error: null | GenericError;
  requestStatus: RequestStatus;

  formStrikePrices: Omit<StrikePrice, 'id'>[] | null;
  strikePrices: StrikePrice[] | null;
  selectedStrikePrice: StrikePrice | null;
  resAddStrikePrice: RequestStatus;
  resEditStrikePrice: RequestStatus;
  resRemoveStrikePrice: RequestStatus;
}

export interface JsonLoanStrikesSuccess {
  command: 'LoanStrikes';
  loanID: number;
  strikes: JsonStrikePrice[];
}
